<template>
  <div
    v-if="server.is_enabled"
    class="hint-hover server"
    :class="{
      server_status_on: server.status === 'on',
      server_status_off: server.status === 'off',
      priority_1: parseInt(server.order) === 1,
      priority_2: parseInt(server.order) === 2,
      priority_3: parseInt(server.order) === 3,
      priority_4: parseInt(server.order) === 4,
      priority_5: parseInt(server.order) === 5,
      priority_6: parseInt(server.order) === 6,
    }"
    :style="{ zIndex: calculateZIndex() }"
  >
    <router-link
      :to="{ name: 'Server', params: { id: parseInt(server.id) } }"
      class="server__link"
      :aria-label="server.name"
      data-inner-select="server"
      @click="this.$store.dispatch('open_modal', $event)"
    ></router-link>
    <div class="server__status" translate="no">
      <div class="server__state_online server__state_online_on">{{ $t('server_item.on') }}</div>
      <div class="server__state_online server__state_online_off">{{ $t('server_item.off') }}</div>
    </div>
    <div class="server__progress" :data-online="server.status === 'on' ? server.online : 0"></div>
    <div class="server__content" translate="no">
      <div class="server__front">
        <div class="server__life life notranslate" data-start-time>
          <div
            class="life__title"
            :class="{
              life__title_new: displayTitle !== lifeTimeAbbr,
            }"
          >
            {{ displayTitle }}
          </div>
          <div class="life__days">
            {{ $tc('server_item.day', displayDays, { count: displayDays }) }}
          </div>
          <div class="life__time">
            {{ displayHours + ':' + displayMinutes + ':' + displaySeconds }}
          </div>
        </div>
        <div class="server__title">
          {{ server.name }}
          <span class="server__name">x{{ server.rate }}</span>
        </div>
      </div>
      <div class="server__back">
        <div class="server__title">{{ $t('server_item.online') }}</div>
        <div class="server__online">
          {{ server.status === 'on' ? server.online : 0 }}
        </div>
      </div>
    </div>
    <div class="server__hint hint">
      <div class="hint__btn">
        <div class="hint__arrow"></div>
      </div>
      <div class="hint__list hint_size_large">
        <ServerLink
          v-for="(server_link, index) in server_links"
          :key="index"
          :link="server_link"
          :server_id="parseInt(server.id)"
          :desc-link="server.desc_link"
        ></ServerLink>
      </div>
    </div>
  </div>
</template>

<script>
import { serverInitCircleProgress } from '@/assets/js/servers';
import ServerLink from '@/components/Body/Servers/ServerLink';

export default {
  name: 'ServerItem',
  components: { ServerLink },
  props: {
    server: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      main_server_id: 1,
      circle_initiated: false,
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      displayTitle: null,
    };
  },
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
    _sid() {
      return this.$props.server.id;
    },
    server_links: {
      get() {
        return this.$store.getters.get_server_links;
      },
    },
    monthNames() {
      return [
        this.$t('server_item.month_january'),
        this.$t('server_item.month_february'),
        this.$t('server_item.month_march'),
        this.$t('server_item.month_april'),
        this.$t('server_item.month_may'),
        this.$t('server_item.month_june'),
        this.$t('server_item.month_july'),
        this.$t('server_item.month_august'),
        this.$t('server_item.month_september'),
        this.$t('server_item.month_october'),
        this.$t('server_item.month_november'),
        this.$t('server_item.month_december'),
      ];
    },
    lifeTimeAbbr() {
      return this.$t('server_item.life_time');
    },
  },
  methods: {
    calculateZIndex() {
      // Calculate z-index dynamically based on server order
      // Lower order (higher priority) gets higher z-index
      // This ensures servers with lower order numbers don't get overlapped
      const order = parseInt(this.server.order) || 999;

      // For mobile view, we want to ensure row 1 servers have higher z-index than row 2
      // Window width check helps apply this only in mobile view
      if (window.innerWidth <= 700) {
        // First row (usually orders 1-3) get higher z-index
        if (order <= 3) {
          return 10 - order; // Results in z-index: 9, 8, 7 for orders 1, 2, 3
        } else {
          return 5 - order; // Lower z-index for second row
        }
      }

      // Default z-index calculation for non-mobile views
      return 10 - order; // Higher priority (lower order) gets higher z-index
    },
    minutes_format: num => (num < 10 ? '0' + num : num),
    showRemaining() {
      setInterval(() => {
        const now = new Date();
        const end = new Date(this.server.start);
        const started = now.getTime() > end.getTime();

        this.displayTitle = !started
          ? this.monthNames[end.getMonth()] + ' ' + end.getDate()
          : this.lifeTimeAbbr;

        const distance = Math.abs(end.getTime() - now.getTime());

        const days = Math.floor(distance / this._days);
        const hours = Math.floor((distance % this._days) / this._hours);
        const minutes = Math.floor((distance % this._hours) / this._minutes);
        const seconds = Math.floor((distance % this._minutes) / this._seconds);

        this.displayDays = days;
        this.displayHours = this.minutes_format(hours);
        this.displayMinutes = this.minutes_format(minutes);
        this.displaySeconds = this.minutes_format(seconds);
      }, 1000);
    },
  },
  updated() {
    if (!this.circle_initiated) {
      setTimeout(() => serverInitCircleProgress(), 500);
    }
    this.circle_initiated = true;
  },
  mounted() {
    this.$store.dispatch('fetch_modal_links');
    this.showRemaining();
  },
};
</script>

<style scoped></style>
